module.exports = __webpack_public_path__ + "img/protect-privacy.9fa70022.svg";